import React from "react";
import DocumentViewerNative from "components/DocumentViewer/DocumentViewerNative";

const TermsOfUseNativePage: React.FC = () => {
    return (
        <DocumentViewerNative
            titleKey="pages.login.termsOfUse"
            documentType="terms"
        />
    );
};

export default TermsOfUseNativePage;
